import React, { useState } from 'react';
import fallbackImage from '../../assets/images/placeholders/image-fallback.svg';

const ImageWithFallback = ({ src, alt, className = '', fallbackSrc, onLoad, onError }) => {
  const [effectiveSrc, setEffectiveSrc] = useState(src || (fallbackSrc || fallbackImage));

  const handleError = (e) => {
    if (effectiveSrc !== (fallbackSrc || fallbackImage)) {
      setEffectiveSrc(fallbackSrc || fallbackImage);
    }
    if (typeof onError === 'function') {
      onError(e);
    }
  };

  const handleLoad = (e) => {
    if (typeof onLoad === 'function') {
      onLoad(e);
    }
  };

  return (
    <img
      src={effectiveSrc}
      alt={alt || ''}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      loading="lazy"
    />
  );
};

export default ImageWithFallback;